



















export default
	props:
		pageTitle: String

	data: ->
		showCopiedSuccess: false

	computed:
		currentURL: -> process.env.URL + @$route.fullPath
		shareLinks: ->
			email:
				href: "mailto:?subject=Check out this article&body=Check out this article: #{@currentURL}"
				title: "Share by Email"

			twitter:
				href: "https://twitter.com/intent/tweet?text=Check+this+out:+&url=#{@currentURL}&via=CAoliveranch"

			# Requires FB App ID!!!
			facebook:
				href: "https://www.facebook.com/sharer/sharer.php?u=#{ @currentURL }"

			linkedIn:
				href: "https://www.linkedin.com/sharing/share-offsite/?&url=#{ @currentURL }&title=Check+out+this+article"

			pinterest:
				href: "http://pinterest.com/pin/create/button/?url=#{ @currentURL }&description=#{ @pageTitle }"

		shareTo: ->
			"Share #{ @pageTitle }"

	methods:
		onClick: (shareTarget) ->
			switch shareTarget
				when 'copy'
					navigator.clipboard.writeText @currentURL
					@showCopiedSuccess = true
					@$wait 1500, => @showCopiedSuccess = false
				else
					return window.open @shareLinks[shareTarget].href, @shareTo, 'resizable, height=600,width=700'

